import { api } from 'api'
import { toaster } from 'uikit/Toaster'
import { useMutation } from '@tanstack/react-query'

export const useFetchStats = () => {
  return useMutation({
    mutationFn: (payload) => {
      return api.payments.fetchSum(payload)
    },
    onError: (err) => {
      toaster.create({
        type: 'error',
        title: 'Произошла ошибка при загрузке статистики',
        description: err.message,
      })
    },
    gcTime: 0,
  })
}
